import * as Actions from '../actions';

const initialState = {
	providers: [],
	users: [],
	clusterSettings: [],
	ldapServers: [],
	emailSettings: null,
	emailSettingsLoading: false,
	emailSettingsError: null,
	twoStepVerification: null,
	oidcConfigs: [],
	acmEnabled: null,
	aiFeaturesEnabled: null,
	healthServiceStatus: { enabled: true },
	theme: 'default',
	workshopSettings: {
		codeMode: 'shared',
		style: 'standard',
		enableSudoForAllUsers: false,
		enableClusterFallback: false
	},
	// Provider Visibility (003-in-the-ui)
	providerVisibility: {
		data: null,
		loading: false,
		error: null
	},
	providerVisibilityCheck: {
		data: null,
		loading: false,
		error: null
	}
};

const settingsReducer = function (state = initialState, action) {
	switch (action.type) {
		case Actions.SET_ACM_ENABLED: {
			return {
				...state,
				acmEnabled: action.payload,
				error: null,
			};
		}
		case Actions.SET_AI_FEATURES_ENABLED: {
			return {
				...state,
				aiFeaturesEnabled: action.payload,
				error: null,
			};
		}
		case Actions.SET_ACM_MACHINES: {
			return {
				...state,
				machines: action.payload,
				error: null,
			};
		}
		case Actions.SET_ACTIONS_ERROR: {
			return {
				...state,
				error: action.payload,
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null,
			};
		}
		case Actions.CLEAR_SETTINGS_REDUCER: {
			return initialState;
		}
		case Actions.SET_CLUSTER_SETTINGS: {
			return {
				...state,
				clusterSettings: action.payload.clusterSettings,
				error: null,
			};
		}
		case Actions.SET_UI_SETTINGS: {
			return {
				...state,
				ui: action.payload,
				error: null,
			};
		}
		case Actions.SET_LDAP_SERVERS: {
			return {
				...state,
				ldapServers: action.payload,
				error: null,
			};
		}
		case Actions.SET_LDAP_ERROR: {
			return {
				...state,
				ldapError: action.payload,
			};
		}
		case Actions.SET_EMAIL_SETTINGS: {
			return {
				...state,
				emailSettings: action.payload,
				emailSettingsError: null,
			};
		}
		case Actions.SET_EMAIL_SETTINGS_ERROR: {
			return {
				...state,
				emailSettingsError: action.payload,
			};
		}
		case Actions.SET_EMAIL_SETTINGS_LOADING: {
			return {
				...state,
				emailSettingsLoading: action.payload,
			};
		}
		case Actions.SET_TWO_STEP_VERIFICATION_SETTINGS: {
			return {
				...state,
				twoStepVerification: action.payload,
				error: null,
			};
		}
		case Actions.SET_TWO_STEP_VERIFICATION_ERROR: {
			return {
				...state,
				twoStepVerificationError: action.payload,
			};
		}
		case Actions.SET_OPENID_CONFIGS: {           
			return {
				...state,
				oidcConfigs: action.payload,
				error: null,
			};
		}
		case Actions.SET_OPENID_ERROR: {             
			return {
				...state,
				oidcError: action.payload,
			};
		}
		case Actions.SET_HEALTH_SERVICE_STATUS: {
			return {
				...state,
				healthServiceStatus: action.payload,
				error: null,
			};
		}
		case Actions.SET_THEME: {
			return {
				...state,
				theme: action.payload,
				error: null,
			};
		}
		case Actions.SET_WORKSHOP_SETTINGS: {
			return {
				...state,
				workshopSettings: {
					...state.workshopSettings,
					...action.payload
				},
				error: null,
			};
		}
		// Provider Visibility Cases (003-in-the-ui)
		case Actions.GET_PROVIDER_VISIBILITY_REQUEST: {
			return {
				...state,
				providerVisibility: {
					...state.providerVisibility,
					loading: true,
					error: null
				}
			};
		}
		case Actions.GET_PROVIDER_VISIBILITY_SUCCESS: {
			return {
				...state,
				providerVisibility: {
					data: action.payload,
					loading: false,
					error: null
				}
			};
		}
		case Actions.GET_PROVIDER_VISIBILITY_FAILURE: {
			return {
				...state,
				providerVisibility: {
					...state.providerVisibility,
					loading: false,
					error: action.payload
				}
			};
		}
		case Actions.UPDATE_PROVIDER_VISIBILITY_REQUEST: {
			return {
				...state,
				providerVisibility: {
					...state.providerVisibility,
					loading: true,
					error: null
				}
			};
		}
		case Actions.UPDATE_PROVIDER_VISIBILITY_SUCCESS: {
			return {
				...state,
				providerVisibility: {
					data: action.payload,
					loading: false,
					error: null
				}
			};
		}
		case Actions.UPDATE_PROVIDER_VISIBILITY_FAILURE: {
			return {
				...state,
				providerVisibility: {
					...state.providerVisibility,
					loading: false,
					error: action.payload
				}
			};
		}
		case Actions.CHECK_PROVIDER_VISIBILITY_REQUEST: {
			return {
				...state,
				providerVisibilityCheck: {
					...state.providerVisibilityCheck,
					loading: true,
					error: null
				}
			};
		}
		case Actions.CHECK_PROVIDER_VISIBILITY_SUCCESS: {
			return {
				...state,
				providerVisibilityCheck: {
					data: action.payload,
					loading: false,
					error: null
				}
			};
		}
		case Actions.CHECK_PROVIDER_VISIBILITY_FAILURE: {
			return {
				...state,
				providerVisibilityCheck: {
					...state.providerVisibilityCheck,
					loading: false,
					error: action.payload
				}
			};
		}
		default:
			return state;
	}
};

export default settingsReducer;
